module.exports = __webpack_public_path__ + "components/weather-icon/static/dayclear-67420c1b6b3deadc194e3d819a95fd68.svg";